import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { recruitNowWebhookQueryKeys } from "./queryKeys";

import { instance } from "@/lib/axios/instance";

export interface ClientWebhookConfiguration {
  webhookId: string | null;
  webhookSecret: string | null;
}

interface ClientWebhookConfigurationResponse {
  webhookId: string | null;
  webhookSecret: string | null;
}

export function useClientWebhookConfiguration(clientId?: string | null) {
  return useQuery<ClientWebhookConfiguration, AxiosError>({
    queryKey: recruitNowWebhookQueryKeys.configuration(clientId),
    queryFn: async () => {
      if (!clientId) {
        throw new Error("Client ID is required");
      }
      const response = await instance.get<ClientWebhookConfigurationResponse>(
        `/api/v2/Webhooks/RecruitNow/Clients/${clientId}/Configuration`
      );
      // Backend returns camelCase JSON (ASP.NET Core default)
      return {
        webhookId: response.data.webhookId ?? null,
        webhookSecret: response.data.webhookSecret ?? null,
      };
    },
    enabled: !!clientId,
    staleTime: 20 * 60 * 1000, // 20 minutes
  });
}
